import { render } from "./ResumeModalEdit.vue?vue&type=template&id=0bac24ba"
import script from "./ResumeModalEdit.vue?vue&type=script&lang=js"
export * from "./ResumeModalEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__